import React from 'react';
import { useDashboard } from '../context/DashboardContext';
import { calculateStats, formatCurrency } from '../utils/helpers';

function SummaryCards() {
  const { transactions } = useDashboard();
  const stats = calculateStats(transactions);

  const cards = [
    {
      title: 'Total Balance',
      amount: stats.totalBalance,
      icon: '💳',
      colorClass: 'card-blue',
    },
    {
      title: 'Total Income',
      amount: stats.totalIncome,
      icon: '📈',
      colorClass: 'card-green',
    },
    {
      title: 'Total Expenses',
      amount: stats.totalExpenses,
      icon: '📉',
      colorClass: 'card-red',
    },
  ];

  return (
    <div className="summary-grid">
      {cards.map((card) => (
        <div key={card.title} className={`summary-card ${card.colorClass}`}>
          <div className="summary-card__body">
            <p className="summary-card__label">{card.title}</p>
            <h3 className="summary-card__amount">{formatCurrency(card.amount)}</h3>
          </div>
          <div className="summary-card__icon">{card.icon}</div>
        </div>
      ))}
    </div>
  );
}

export default SummaryCards;
